import { Alert, AlertIcon, Center, Container } from "@chakra-ui/react";
import * as React from "react";
export interface DisplayErrorProps {
  error: Error;
}
export function DisplayError(error: DisplayErrorProps) {
  return (
    <Center m={10}>
      <Container>
        <Alert status="warning" bgColor={process.env.REACT_APP_PARTNER_SECONDARY}>
          <AlertIcon color={process.env.REACT_APP_PARTNER_PRIMARY} />
          Nessun prodotto trovato. Prova a cambiare i criteri di ricerca.
        </Alert>
      </Container>
    </Center>
  );
}
